import React from "react";
import LotSummaryPreview from "./LotSummaryPreview";

const ProductDetailsSection = ({
  formData,
  Lot,
  activeTab,
  handleInputChange,
  toggleHandleLot,
  openLotDrawer,
  getSizeUnit,
  getSizeInfo,
  lotSizes,
  totals,
}) => {
  const sizeInfo = typeof getSizeInfo === "function" ? getSizeInfo() : null;
  const sizeUnit = typeof getSizeUnit === "function" ? getSizeUnit() : "";
  const sizeOptions = sizeInfo?.options || [];

  return (
    <div className="section">
      <div className="productDetails">
        <div className="section-title">Product Details</div>
        <div className="toggle-switch-wrapper">
          <label className="toggle-switch">
            <input type="checkbox" checked={Lot} onChange={toggleHandleLot} />
            <span className="toggle-slider">
              <span className="toggle-text">{Lot ? "MULTI" : "SINGLE"}</span>
              <span className="toggle-knob" />
            </span>
          </label>
        </div>
      </div>

      <div className="form-grid-2">
        <div className="form-group">
          <label className="form-label required">Design Code</label>
          <input
            type="text"
            maxLength={8}
            value={formData.designCode}
            onChange={(e) => handleInputChange("designCode", e.target.value)}
            className="form-input"
            placeholder="Enter Design Code"
          />
        </div>
        <div className="form-group">
          <label className="form-label required">MOQ Set</label>
          <input
            type="text"
            value={formData.moqSet}
            onChange={(e) => handleInputChange("moqSet", e.target.value)}
            className="form-input"
            placeholder="Enter MOQ "
          />
        </div>
      </div>

      {/* Sizing unit + size options resolved from SellerSegment for the selected product */}
      {sizeInfo && (sizeUnit || sizeOptions.length > 0) && (
        <div
          className="sizing-meta"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "8px 16px",
            margin: "0 0 1rem",
            padding: "8px 12px",
            backgroundColor: "#f8fafc",
            border: "1px solid #e2e8f0",
            borderRadius: "6px",
            fontSize: "13px",
            color: "#334155",
          }}
        >
          {sizeUnit && (
            <span>
              <strong>Sizing Unit:</strong> {sizeUnit}
            </span>
          )}
          {sizeOptions.length > 0 && (
            <span>
              <strong>Size Options:</strong> {sizeOptions.join(", ")}
            </span>
          )}
          {sizeInfo.note && (
            <span style={{ color: "#64748b" }}>{sizeInfo.note}</span>
          )}
        </div>
      )}

      <LotSummaryPreview
        formData={formData}
        Lot={Lot}
        activeTab={activeTab}
        lotSizes={lotSizes}
        totals={totals}
        getSizeUnit={getSizeUnit}
        getSizeInfo={getSizeInfo}
        openLotDrawer={openLotDrawer}
      />

      <div
        style={{
          marginTop: "1rem",
          display: "flex",
          flexDirection: "column",
          gap: "0.5rem",
        }}
      >
        <label
          style={{
            fontWeight: 600,
            color: "#222",
            fontSize: "1rem",
            marginBottom: "0.25rem",
          }}
        >
          Payment Method
        </label>
        <div style={{ display: "flex", gap: "2rem", alignItems: "center" }}>
          {["RTGS", "Metal"].map((method) => (
            <label
              key={method}
              htmlFor={`payment-${method.toLowerCase()}`}
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                color: "#333",
                fontSize: "0.95rem",
                position: "relative",
                userSelect: "none",
                gap: "0.5rem",
              }}
            >
              <input
                type="radio"
                name="paymentMethod"
                id={`payment-${method.toLowerCase()}`}
                value={method}
                checked={formData.paymentMethod === method}
                onChange={(e) =>
                  handleInputChange("paymentMethod", e.target.value)
                }
                style={{ display: "none" }}
              />
              <span
                style={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  border: "2px solid #c49b27",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor:
                    formData.paymentMethod === method
                      ? "#c49b27"
                      : "transparent",
                  boxShadow:
                    formData.paymentMethod === method
                      ? "0 0 5px rgba(196,155,39,0.6)"
                      : "none",
                  transition: "all 0.25s ease",
                }}
              >
                {formData.paymentMethod === method && (
                  <span
                    style={{
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                      backgroundColor: "#fff",
                    }}
                  />
                )}
              </span>
              {method}
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsSection;
